import { createStructuredSelector } from 'reselect'

import {
  EXTERNAL_REVIEW_DETAIL,
  EXTERNAL_REVIEW_DETAIL_SUCCESS,
  EXTERNAL_REVIEW_DETAIL_ERROR,
  EXTERNAL_REVIEW_ADD_SET,
  EXTERNAL_REVIEW_ADD_CHANGE,
  EXTERNAL_REVIEW_EDIT_MODAL_SET,
  EXTERNAL_REVIEW_ADD_MODAL_SET,
  EXTERNAL_REVIEW_EDIT_TAB_SET,
  EXTERNAL_REVIEW_SEARCH,
  EXTERNAL_REVIEW_SEARCH_SUCCESS,
  EXTERNAL_REVIEW_SEARCH_ERROR,
  EXTERNAL_REVIEW_ADD,
  EXTERNAL_REVIEW_ADD_SUCCESS,
  EXTERNAL_REVIEW_ADD_ERROR,
  EXTERNAL_REVIEW_HEADER,
  EXTERNAL_REVIEW_SEARCH_EXTERNAL_REVIEW_STATE_LIST,
  EXTERNAL_REVIEW_SEARCH_EXTERNAL_REVIEW_STATE_LIST_SUCCESS,
  EXTERNAL_REVIEW_SEARCH_EXTERNAL_REVIEW_STATE_LIST_ERROR,
  EXTERNAL_REVIEW_SEARCH_SUPPLIER_LIST,
  EXTERNAL_REVIEW_SEARCH_SUPPLIER_LIST_SUCCESS,
  EXTERNAL_REVIEW_SEARCH_SUPPLIER_LIST_ERROR,
  EXTERNAL_REVIEW_LIST,
  EXTERNAL_REVIEW_LIST_SUCCESS,
  EXTERNAL_REVIEW_LIST_ERROR,
  EXTERNAL_REVIEW_SEARCH_SET,
  EXTERNAL_REVIEW_SEARCH_CHANGE,
  EXTERNAL_REVIEW_PAGE_SET,
  EXTERNAL_REVIEW_VIEW_MODAL_SET,
  EXTERNAL_REVIEW_VIEW_DETAIL_MODAL_SET,
  EXTERNAL_REVIEW_VIEW_SET,
  EXTERNAL_REVIEW_VIEW_TAB_SET,
  EXTERNAL_REVIEW_EDIT_CHANGE,
  EXTERNAL_REVIEW_UPDATE,
  EXTERNAL_REVIEW_UPDATE_SUCCESS,
  EXTERNAL_REVIEW_UPDATE_ERROR
} from '../actions';

export const NAME = 'external_review';

export const ExternalReviewDetail = (data) => ({
  type: EXTERNAL_REVIEW_DETAIL,
  payload: data
});

export const ExternalReviewDetailSuccess = (data) => ({
  type: EXTERNAL_REVIEW_DETAIL_SUCCESS,
  payload: data
});

export const ExternalReviewDetailError = (error) => ({
  type: EXTERNAL_REVIEW_DETAIL_ERROR,
  payload: error
});

export const ExternalReviewAddSet = (data) => ({
  type: EXTERNAL_REVIEW_ADD_SET,
  payload: data
});

export const ExternalReviewAddChangeSet = (data) => ({
  type: EXTERNAL_REVIEW_ADD_CHANGE,
  payload: data
});

export const ExternalReviewEditModalSet = (data) => ({
  type: EXTERNAL_REVIEW_EDIT_MODAL_SET,
  payload: data
});

export const ExternalReviewAddModalSet = (data) => ({
  type: EXTERNAL_REVIEW_ADD_MODAL_SET,
  payload: data
});

export const ExternalReviewEditTabSet = (data) => ({
  type: EXTERNAL_REVIEW_EDIT_TAB_SET,
  payload: data
});

export const ExternalReviewViewTabSet = (data) => ({
  type: EXTERNAL_REVIEW_VIEW_TAB_SET,
  payload: data
});

export const ExternalReviewSearch = (data) => ({
  type: EXTERNAL_REVIEW_SEARCH,
  payload: data
});

export const ExternalReviewSearchSuccess = (data) => ({
  type: EXTERNAL_REVIEW_SEARCH_SUCCESS,
  payload: data
});

export const ExternalReviewSearchError = (error) => ({
  type: EXTERNAL_REVIEW_SEARCH_ERROR,
  payload: error
});

export const ExternalReviewAdd = (data) => ({
  type: EXTERNAL_REVIEW_ADD,
  payload: data
});

export const ExternalReviewAddSuccess = (data) => ({
  type: EXTERNAL_REVIEW_ADD_SUCCESS,
  payload: data
});

export const ExternalReviewAddError = (error) => ({
  type: EXTERNAL_REVIEW_ADD_ERROR,
  payload: error
});

export const ExternalReviewHeader = (data) => ({
  type: EXTERNAL_REVIEW_HEADER,
  payload: data
});

export const ExternalReviewSearchExternalReviewStateList = () => ({
  type: EXTERNAL_REVIEW_SEARCH_EXTERNAL_REVIEW_STATE_LIST
});

export const ExternalReviewSearchExternalReviewStateListSuccess = (message) => ({
  type: EXTERNAL_REVIEW_SEARCH_EXTERNAL_REVIEW_STATE_LIST_SUCCESS,
  payload: message
});

export const ExternalReviewSearchExternalReviewStateListError = (error) => ({
  type: EXTERNAL_REVIEW_SEARCH_EXTERNAL_REVIEW_STATE_LIST_ERROR,
  payload: error
});

export const ExternalReviewSearchSupplierList = () => ({
  type: EXTERNAL_REVIEW_SEARCH_SUPPLIER_LIST
});

export const ExternalReviewSearchSupplierListSuccess = (message) => ({
  type: EXTERNAL_REVIEW_SEARCH_SUPPLIER_LIST_SUCCESS,
  payload: message
});

export const ExternalReviewSearchSupplierListError = (error) => ({
  type: EXTERNAL_REVIEW_SEARCH_SUPPLIER_LIST_ERROR,
  payload: error
});

export const ExternalReviewList = (page, num_page, orderBy, filters, stateFilter) => ({
  type: EXTERNAL_REVIEW_LIST,
  payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const ExternalReviewListSuccess = (data) => ({
  type: EXTERNAL_REVIEW_LIST_SUCCESS,
  payload: data
});

export const ExternalReviewListError = (error) => ({
  type: EXTERNAL_REVIEW_LIST_ERROR,
  payload: error
});

export const ExternalReviewSearchSet = (data) => ({
  type: EXTERNAL_REVIEW_SEARCH_SET,
  payload: data
});

export const ExternalReviewSearchChangeSet = (data) => ({
  type: EXTERNAL_REVIEW_SEARCH_CHANGE,
  payload: data
});

export const ExternalReviewPageSet = (data) => ({
  type: EXTERNAL_REVIEW_PAGE_SET,
  payload: data
});

export const ExternalReviewViewModalSet = (data) => ({
  type: EXTERNAL_REVIEW_VIEW_MODAL_SET,
  payload: data
});

export const ExternalReviewViewDetailModalSet = (data) => ({
  type: EXTERNAL_REVIEW_VIEW_DETAIL_MODAL_SET,
  payload: data
});


export const ExternalReviewViewSet = (data) => ({
  type: EXTERNAL_REVIEW_VIEW_SET,
  payload: data
});

export const ExternalReviewEditChangeSet = (data) => ({
  type: EXTERNAL_REVIEW_EDIT_CHANGE,
  payload: data
});

export const ExternalReviewUpdate = (data) => ({
  type: EXTERNAL_REVIEW_UPDATE,
  payload: data
});

export const ExternalReviewUpdateSuccess = (message) => ({
  type: EXTERNAL_REVIEW_UPDATE_SUCCESS,
  payload: message.message
});

export const ExternalReviewUpdateError = (error) => ({
  type: EXTERNAL_REVIEW_UPDATE_ERROR,
  payload: error
});

const external_review = (state) => state[NAME];
export const ExternalReviewSelector = createStructuredSelector({
  external_review
})
